export const standards = {
  Add_new_requirement: "Agregar nuevo requisito",
  Add_requirement: "Agregar_requisito",
  Add_section: "Agregar_sección",
  Add_subsection: "Agregar subsección",
  All_Clients: "Todos los clientes",
  Content: "Contenido",
  Edit_requirement: "Requisito de edición",
  Expand_all: "Expandir todo",
  Full_name: "Nombre completo",
  Please_fill_in_the_requirement_information: "Por favor, rellene la información requerida",
  Published_date: "Fecha de publicación",
  Read_less: "Sin lectura",
  Read_more: "Leer más",
  Reference: "Referencia",
  Requirement_Info: "Información de requisitos",
  Section_Reference: "Sección Referencia",
  Section_reference_is_required: "Se requiere la referencia de la sección",
  Section_title: "Título de la sección",
  Section_title_is_required: "Se requiere el título de la sección",
  Section_with_this_reference_already_exists: "La sección con esta referencia y título ya existe",
  Sections: "Secciones",
  Standard_Body: "Cuerpo Estándar",
  Standard_Guidance: "Guía estándar",
  Standard_ID: "Estándar ID",
  Sub_Section_with_this_title_already_exists: "La subsección con esta referencia y título ya existe",
  Sub_Sections: "Sub Secciones",
  "Sub-Section_Reference": "Sub Secciones Referencia",
  "Sub-Section_title": "Título de la subsección",
  Tenants: "Inquilinos",
  This_cannot_be_deleted_until_all_the_associated_requirements_and_sub_sections_are_removed_first:
    "Esto no se puede eliminar hasta que se eliminen primero todos los requisitos y subsecciones asociados.",
  This_cannot_be_deleted_until_all_the_associated_requirements_are_removed_first:
    "Esto no se puede eliminar hasta que se eliminen primero todos los requisitos asociados.",
  Version: "Versión",
  You_are_adding_a_new_requirement_to: "Estás agregando un nuevo requisito a:",
} as const;
